// src/pages/admin/JobsList.js
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Button } from "@mui/material";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import { Box } from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import { DataGrid } from "@mui/x-data-grid";
import { Modal, ModalClose, Sheet, Typography } from "@mui/joy";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function JobsList() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [jobs, setJobs] = useState([]);
  const [callApi, setCallApi] = useState(false);
  const [warning, setWarning] = useState({ text: "", id: null });
  const [openWarning, setOpenWarning] = useState(false);

  // fetch
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}common/jobs`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((r) => setJobs(r.data))
      .catch(() => {
        alert("Session expired");
        localStorage.clear();
        navigate("/login");
      });
  }, [token, callApi, navigate]);

  // delete
  const deleteJob = async (id) => {
    await axios.delete(`${process.env.REACT_APP_BASE_URL}common/jobs/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setCallApi((c) => !c);
  };

  // toggle active
  const toggleActive = async (id) => {
    const job = jobs.find((j) => j._id === id);
    await axios.put(
      `${process.env.REACT_APP_BASE_URL}common/jobs/${id}`,
      { active: !job.active },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setCallApi((c) => !c);
  };

  // table
  const columns = [
    { field: "s_no", headerName: "S.no", width: 80 },
    { field: "jobNumber", headerName: "Job Number", width: 150 },
    { field: "description", headerName: "Description", width: 300 },
    { field: "active", headerName: "Active", width: 100 },
    {
      field: "actions",
      headerName: "Actions",
      width: 300,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: ".5rem" }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => navigate(`/edit-job/${params.row.id}`)}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="contained"
            color={params.row.active === "Yes" ? "success" : "error"}
            onClick={() => {
              setWarning({
                text: `Set ${params.row.active === "Yes" ? "Inactive" : "Active"}?`,
                id: params.row.id,
              });
              setOpenWarning(true);
            }}
          >
            {params.row.active}
          </Button>
          <Button
            size="small"
            variant="contained"
            color="error"
            onClick={() => {
              setWarning({ text: "Delete this job?", id: params.row.id });
              setOpenWarning(true);
            }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const rows = jobs.map((j, i) => ({
    id: j._id,
    s_no: i + 1,
    jobNumber: j.jobNumber,
    description: j.description || "—",
    active: j.active ? "Yes" : "No",
  }));

  return (
    <PageLayout>
      <Grid container spacing={2} className="mb-2 align-items-center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Breadcrumb title="Jobs List" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} className="text-end">
          <Link to="/add-job">
            <Button variant="contained" color="primary">Create Job</Button>
          </Link>
        </Grid>
      </Grid>
      <Box className="mc-card">
        <CardHeader title="Jobs" />
        <div style={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: { paginationModel: { pageSize: 25 } },
            }}
            pageSizeOptions={[25, 50, 100]}
            disableRowSelectionOnClick
          />
        </div>
      </Box>

      <Modal
        open={openWarning}
        onClose={() => setOpenWarning(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            width: "30%",
            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
            bgcolor: "#fff",
          }}
        >
          <ModalClose sx={{ top: 8, right: 8 }} />
          <Typography fontSize="1.25em" mb={3}>
            {warning.text}
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "2rem",
            }}
          >
            <Button
              variant="contained"
              color="success"
              style={{ width: "8rem" }}
              onClick={() => {
                if (warning.text.includes("Delete")) deleteJob(warning.id);
                else toggleActive(warning.id);
                setOpenWarning(false);
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ width: "8rem" }}
              onClick={() => setOpenWarning(false)}
            >
              No
            </Button>
          </div>
        </Sheet>
      </Modal>
    </PageLayout>
  );
}
